var map = {
	"./ADF.png": 4747,
	"./SQLite.png": 9140,
	"./azure.png": 6068,
	"./bootstrap.png": 7294,
	"./confluence.png": 5085,
	"./databricks.png": 8443,
	"./devops.png": 2986,
	"./flutter.png": 1722,
	"./gcp.png": 7625,
	"./github.png": 1791,
	"./hadoop.png": 612,
	"./intellij.png": 6631,
	"./jQuery.png": 4599,
	"./jira.png": 8744,
	"./jupyter.png": 682,
	"./linux.png": 700,
	"./matplotlib.png": 6245,
	"./mySQL.png": 6506,
	"./numpy.png": 9025,
	"./oracle.png": 3582,
	"./pandas.png": 1270,
	"./powerBI.png": 5849,
	"./pytorch.png": 5206,
	"./scikitLearn.png": 1121,
	"./spark.png": 9394,
	"./sqlServer.png": 7530,
	"./vscode.png": 9884,
	"./vue.png": 2929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5291;